import gql from "graphql-tag";

export default gql`
  mutation MarkAllNotificationsRead {
    markAllNotificationsRead(input: {}) {
      __typename
    }
  }
`;
